import ConfirmationModal from 'uilib-wrappers/confirmation-modal';
import Button from 'uilib-wrappers/button';
import Text from 'uilib-wrappers/text';
import Link from 'uilib-wrappers/link';
import Checkbox from '@uilib/business-components/Checkbox/Checkbox';
import { checkState } from '@uilib/business-components/Checkbox';
import Spacer from '@uilib/core/Spacer/Spacer';
import Progress from 'Bricks/Progress';

import i18n from 'Services/i18n';
import { useState } from 'react';
import { BACKEND } from 'Services/backend';
import { PROTECT_REDIRECTION_USER_SETTING } from './helpers';

// Global confirmation modal that can be displayed before redirection to Protect
export default function ProtectRedirectionModal({ content }) {
    const [isChecked, setChecked] = useState(checkState.unchecked);
    const [showProgress, setShowProgress] = useState(false);

    if (!content) return null;

    const { modal, componentUuid, onConfirm, onCancel, onClose } = content;

    function close() {
        setShowProgress(false);
        onClose();
    }

    function handleConfirm() {
        if (!isChecked) {
            onConfirm();
            close();
            return;
        }

        setShowProgress(true);
        BACKEND.put(PROTECT_REDIRECTION_USER_SETTING, { [modal.settingKey]: '0' }, componentUuid)
            .always(() => {
                onConfirm();
                close();
            })
            .execute();
    }

    function handleCancel() {
        onCancel();
        close();
    }

    function handleMoreInfo() {
        if (modal.moreInfoLink) {
            window.open(modal.moreInfoLink, '_blank');
        }
    }

    return (
        <ConfirmationModal
            show
            title={i18n('REDIRECTING_TO_ESET_PROTECT')}
            onDispose={handleCancel}
            buttons={[
                <Button
                    id="eid-protect-redirection-button-confirm"
                    type="primary"
                    text="OPEN_IN_ESET_PROTECT"
                    onClick={handleConfirm}
                />,
                <Button
                    id="eid-protect-redirection-button-cancel"
                    type="secondary"
                    text="CANCEL"
                    onClick={handleCancel}
                />,
            ]}
        >
            <Text>{i18n(modal.description)}</Text>
            {modal.moreInfoLink && (
                <Spacer type="pt-2">
                    <Link onClick={handleMoreInfo} text="MORE_INFORMATION" />
                </Spacer>
            )}
            <Spacer type="mt-4">
                <Checkbox
                    onChange={(checked) => setChecked(checked)}
                    text={i18n('DONT_WANT_TO_DISPLAY_THIS_MESSAGE_AGAIN')}
                    testDataLabel="eid-checkbox"
                />
            </Spacer>
            <Progress showProgress={showProgress} />
        </ConfirmationModal>
    );
}
